// ABOUTME: Computes visible job view tabs from module and access constraints.
// ABOUTME: Keeps tab filtering testable without loading React-only view dependencies.
import {
    IMainState,
    PageToRenderList,
    PageToRenderType
} from "./useJobContext/JobViewTypes";

export const isWhatsappApplicationPageAllowed = (
    module: IMainState["module"],
    whatsappApplicationEnabled: boolean,
    allowEdit: boolean
) => module !== "JOBREQUESTVIEW" && whatsappApplicationEnabled && allowEdit;

export const getTabsList = (
    applicantAccess: {
        allowAdd: boolean;
        allowEdit: boolean;
        allowView: boolean;
        allowDelete: boolean;
    },
    data: IMainState,
    isJobRequestWithoutApplicantAccess: boolean,
    isJobRequestWithoutJobHistoryAccess: boolean,
    whatsappApplicationEnabled: boolean
) => {
    const removeApplicantsTabs =
        (!applicantAccess.allowEdit && data.module !== "JOBREQUESTVIEW") ||
        (isJobRequestWithoutApplicantAccess &&
            data.module === "JOBREQUESTVIEW");
    const removeJobHistoryTabs =
        (!applicantAccess.allowEdit && data.module !== "JOBREQUESTVIEW") ||
        (isJobRequestWithoutJobHistoryAccess &&
            data.module === "JOBREQUESTVIEW");

    const showReports = data.module !== "JOBREQUESTVIEW";
    const showWhatsappApplication = isWhatsappApplicationPageAllowed(
        data.module,
        whatsappApplicationEnabled,
        applicantAccess.allowEdit
    );

    const jobRequestTabsToRemove: PageToRenderType[] = [];
    if (removeApplicantsTabs) {
        jobRequestTabsToRemove.push("pipeline", "applicants", "assessment");
    }
    if (removeJobHistoryTabs) {
        jobRequestTabsToRemove.push("activity", "assessment");
    }

    const filteredPageToRenderList = PageToRenderList.filter(
        (i) => !jobRequestTabsToRemove.includes(i)
    );

    const filtered2 = showReports
        ? filteredPageToRenderList
        : filteredPageToRenderList.filter((i) => i !== "reports");

    return showWhatsappApplication
        ? filtered2
        : filtered2.filter((i) => i !== "whatsappApplication");
};
